import { FormattedMessage } from "react-intl";
import HistoryIcon from "../../../components/Common/SvgIcons/AdminIcons/EngagementCenterIcon/HistoryIcon";
import DistibuteIcon from "../../../components/Common/SvgIcons/DashBoardIcons/DistibuteIcon";
import { colors } from "../../stripeColors";
import { distributionHistory } from "./distributionHistory";
import { recallShotclasses } from "./recallShotclasses";

export let distribute = {
  name: <FormattedMessage id="DISTRIBUTECLASS_TEXT" />,
  path: (tenantName) => `/${tenantName}/distribute`,
  classPath: (tenantName) => `/${tenantName}/distribute/classes`,
  seriesPath: (tenantName) => `/${tenantName}/distribute/series`,
  collectionPath: (tenantName) => `/${tenantName}/distribute/collection`,
  icon: DistibuteIcon,
  buttons: (navigate, tenantName) => [
    {
      key: 1,
      label: recallShotclasses.name,
      path: recallShotclasses.path(tenantName),
      icon: HistoryIcon,
      onClick: () => navigate(recallShotclasses.path(tenantName)),
    },
    {
      key: 2,
      label: distributionHistory.label,
      path: distributionHistory.path(tenantName),
      icon: DistibuteIcon,
      onClick: () => navigate(distributionHistory.path(tenantName)),
    },
  ],
  tiles: (navigate, val1, val2, val3, tenantName) => [
    {
      key: 1,
      label: "Classes",
      path: distribute.classPath(tenantName),
      value: val1,
      color: colors.green,
      onClick: () => navigate(distribute.classPath(tenantName)),
    },
    {
      key: 2,
      label: <FormattedMessage id="PROGRAM_TEXT" />,
      path: distribute.seriesPath(tenantName),
      value: val2,
      color: colors.purple,
      onClick: () => navigate(distribute.seriesPath(tenantName)),
    },
    {
      key: 3,
      label: <FormattedMessage id="COLLECTION_TEXT" />,
      path: distribute.collectionPath(tenantName),
      value: val3,
      color: colors.red,
      onClick: () => navigate(distribute.collectionPath(tenantName)),
    },
  ],
};
